import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Elly Decor</title>
        <meta name="title" content="Privacy Policy | Elly Decor" />
        <meta
          name="description"
          content="Read Elly Decor's privacy policy to understand how we collect, use, and protect your personal information when you use our services."
        />
      </Helmet>

      <div className="auto-container py-3 py-lg-5 text-justify">
        <h2 className='responsive-main-heading'>Privacy Policy for Elly Decor</h2>
        <p className='mb-0 mb-lg-3'><strong>Effective Date:</strong> [Date of Policy Implementation]</p>
        <p className='mb-3 mb-lg-3'>
          Elly Decor ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website, <b>ellydecor.in</b> ("Site"), or interact with our services. This policy applies to all users of our Site.
        </p>

        <h4 className='privacy-page-heading'>1. Information We Collect</h4>
        <ul className='mb-3 mb-lg-0'>
          <li><b>Personal Information:</b> Includes name, email, phone number, and address. We collect this when you:
            <ul>
              <li>Create an account</li>
              <li>Place an order</li>
              <li>Fill out a contact form</li>
              <li>Subscribe to our newsletter</li>
              <li>Participate in surveys or promotions</li>
              <li>Interact with our customer service</li>
            </ul>
          </li>
          <li><b>Non-Personal Information:</b> Includes browser type, operating system, IP address, referring website, pages visited, time spent, and cookies.</li>
          <li><b>Payment Information:</b> Processed securely via third-party gateways; we do not store complete card details.</li>
          <li><b>Communications:</b> Information from emails, phone calls, or other messages.</li>
          <li><b>Marketing Information:</b> Preferences for receiving marketing communications.</li>
        </ul>

        <h4 className='privacy-page-heading'>2. How We Use Your Information</h4>
        <ul className='mb-3 mb-lg-0'>
          <li>To fulfill orders and process payments</li>
          <li>To communicate with you regarding orders or services</li>
          <li>To improve our website and personalize your experience</li>
          <li>To send promotional offers (with your consent)</li>
          <li>To detect and prevent fraud or illegal activities</li>
          <li>To conduct research and analytics</li>
          <li>To comply with legal obligations</li>
        </ul>

        <h4 className='privacy-page-heading'>3. Cookies and Similar Technologies</h4>
        <p>
          We use cookies, web beacons, and similar technologies to enhance your browsing experience.
        </p>
        <ul className='mb-3 mb-lg-0'>
          <li><b>Essential Cookies:</b> Required for basic site functionality.</li>
          <li><b>Analytical Cookies:</b> Help us improve performance and design.</li>
          <li><b>Functionality Cookies:</b> Store preferences like language and region.</li>
          <li><b>Advertising Cookies:</b> Deliver relevant ads based on interests.</li>
        </ul>
        <p>
          You can manage cookies through your browser settings, but disabling them may limit site functionality.
        </p>

        <h4 className='privacy-page-heading'>4. How We Share Your Information</h4>
        <ul className='mb-3 mb-lg-0'>
          <li><b>Service Providers:</b> Payment processors, shipping companies, analytics providers.</li>
          <li><b>Business Partners:</b> Co-branded products or services.</li>
          <li><b>Legal Authorities:</b> As required by law.</li>
          <li><b>Business Transfers:</b> In case of mergers or acquisitions.</li>
          <li><b>With Your Consent:</b> For specific purposes.</li>
          <li><b>Affiliates:</b> Subsidiaries and affiliates.</li>
        </ul>

        <h4 className='privacy-page-heading'>5. Your Choices and Rights</h4>
        <ul  className='mb-3 mb-lg-0'>
          <li>Access and receive a copy of your personal data</li>
          <li>Correct inaccuracies</li>
          <li>Request deletion (with exceptions)</li>
          <li>Object to processing for marketing</li>
          <li>Opt-out of marketing via unsubscribe links or contacting us</li>
          <li>Request data portability</li>
          <li>Withdraw consent</li>
          <li>File a complaint with a supervisory authority</li>
        </ul>

        <h4 className='privacy-page-heading'>6. Data Security</h4>
        <ul>
          <li>Encryption during transmission</li>
          <li>Secure server storage</li>
          <li>Restricted employee access</li>
          <li>Regular security assessments</li>
        </ul>
        <p>While we take strong security measures, no method of transmission is completely secure.</p>

        <h4 className='privacy-page-heading'>7. Data Retention</h4>
        <p>
          We retain personal data as long as necessary for the purposes stated, or as required by law. Account information is kept while your account is active.
        </p>

        <h4 className='privacy-page-heading'>8. Links to Third-Party Websites</h4>
        <p>
          Our Site may link to third-party sites. We are not responsible for their privacy practices.
        </p>

        <h4 className='privacy-page-heading'>9. Children's Privacy</h4>
        <p>
          Our Site is not intended for children under 18. We do not knowingly collect their data.
        </p>

        <h4 className='privacy-page-heading'>10. International Data Transfers</h4>
        <p>
          Your data may be stored on servers outside your country. We ensure proper legal protections are in place.
        </p>

        <h4 className='privacy-page-heading'>11. Changes to This Privacy Policy</h4>
        <p>
          We may update this Privacy Policy from time to time. Changes will be posted here with an updated effective date.
        </p>

        <h4 className='privacy-page-heading'>12. Contact Us</h4>
        <p>
          <b>Elly Decor</b><br />
          Shop No. 2, Block A, CLR Complex, Sector 149, Noida, Uttar Pradesh 201310<br />
          Email: <a href="mailto:info@ellydecor.in">info@ellydecor.in</a><br />
          Phone: <a href="tel:+91 98214 95696">+91 98214 95696</a>
        </p>

        <p>
          <b>Governing Law:</b> This Privacy Policy shall be governed by the laws of India.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
